import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'
import { resolve } from 'path';
Vue.use(Vuex)
export const store = new Vuex.Store({
    state : {
        loadedOffertes : [],
        questions : [],
        pictures : [
            { src: 'https://www.soloya.be/wp-content/uploads/2015/07/Omvormer-Sunny-Boy.jpg', id: 'afajfjadfaadfa323', title: 'Omvormer Sunny Boy' },
            { src: 'https://www.soloya.be/wp-content/uploads/2015/07/Polykristallijne-zonnepanelen-360x250.jpg', id: 'aadsfhbkhlk1241', title: 'Polykristallijne zonnepanelen' }
        ],
        user : null,
        loading : false,
        error : null
    },
    mutations: {
        createOfferte(state,payload){
            state.loadedOffertes.push(payload);
        },
        setUser (state, payload) {
            state.user = payload
        },
        setLoading(state,payload){
            state.loading = payload;
        },
        setError(state,payload){
            state.error = payload;
        },
        clearError(state)
        {
            state.error = null;
        },
        setLoadedOffertes(state,payload)
        {
            state.loadedOffertes = payload;
        },
        setLoadedQuestions(state,payload)
        {
            state.questions = payload;
        }
    },
    actions : {
       loadData ({commit,dispatch}){
           
           dispatch('loadOffertes');
           dispatch('loadQuestions');
       },
       loadOffertes ({commit}){
            firebase.firestore().collection('bids').get()
            .then(function(querySnapshot) {
                const bids = []
                querySnapshot.forEach(function(doc) {
                    const obj = doc.data();
                    const key = doc.id;
                    //add the id to the object
                    bids.push({...obj, id:key});
                    //console.log(obj);
                }
                ); 
                commit('setLoadedOffertes',bids);
            }
            )
            .catch(function(error) {
                console.log("Error getting documents: ", error);
            });
        
        },
        loadQuestions({commit}){
            firebase.firestore().collection('questions').get()
            .then(function(querySnapshot) {
                const questions = []
                querySnapshot.forEach(function(doc) {
                    const obj = doc.data();
                    const key = doc.id;
                    //check if a question has a collection of values
                    var values = [];
                    var valueCollectionName = "questions/"+doc.id+"/values";
                    //If the attribute valuesCollection is set, the values come from a separate collection
                    if(obj.valuesCollection)
                    {
                        valueCollectionName = obj.valuesCollection;
                    }
                    firebase.firestore().collection(valueCollectionName).get().then(function(querySnapshot){
                        querySnapshot.forEach(function(doc) {
                            const val = doc.data();
                           // console.log(doc.data());
                        values.push({...val,id:doc.id});
                        })
                    });
                    questions.push({...obj, id:key,values:values});
                    //console.log(obj);
                }
                ); 
                commit('setLoadedQuestions',questions);
            }
            )
            .catch(function(error) {
                console.log("Error getting documents: ", error);
            });
        
        },
        createOfferte({commit,getters},payload){
            commit('setLoading',true);
            commit('clearError');
            //Extract any binaries from the bid (pictures)
            var binaries = [];
            var bidKey;
            var uploadPromises = [];
            var urlPromises = [];
            for(var attID in payload.bid)
            {
                if(payload.bid[attID] && typeof payload.bid[attID].name == "string" && typeof payload.bid[attID].lastModifiedDate == "object")
                {
                    console.log(attID + " is a file")
                    binaries[attID] = payload.bid[attID];
                    //set the value to null temporarily, we'll set it to the download Url of the image
                    payload.bid[attID] = null;
                }
            }
            //const offerte = payload.bid;
            if(payload.bid.dateCreated)
            {
                if(typeof payload.bid.dateCreated !== 'string')
                {
                    payload.bid.dateCreated =  payload.bid.dateCreated.toISOString();
                }
                
            }
            else
            {
                payload.bid.dateCreated = new Date().toISOString();
            }
            if(payload.bid.dateUpdated)
            {
                if(typeof payload.bid.dateUpdated !== 'string')
                {
                    payload.bid.dateUpdated =  payload.bid.dateUpdated.toISOString();
                }
            }
            else
            {
                payload.bid.dateUpdated = new Date().toISOString();
            }
            
            const currentUserEmail = firebase.auth().currentUser.email;
            //Read out to firebase and store offerte
            firebase.firestore().collection('bids').add({...payload.bid,
                createUserId:getters.user.id,
                createUserEmail:currentUserEmail
            }).
            then((data)=> {
                    console.log("Bid successfully written!");
                    const key = data.id;
                    bidKey = key;
                    payload.bid.id = key;
                    return key;
                    /*commit('createOfferte',{...offerte, id:key});
                    commit('setLoading',false);
                    payload.router.push('/offerte/'+key);*/
                    
                })
                .then(key => {
                   
                    for(var targetField in binaries)
                    {
                        var file = binaries[targetField];
                        var fileName = file.name;
                        var extension = fileName.slice(fileName.lastIndexOf('.'));
                        binaries[targetField].ref = 'bids/' + key + '/' + targetField + extension;
                        uploadPromises[targetField] = firebase.storage().ref(binaries[targetField].ref).put(file)
                        .then(fileData => {
                            firebase.storage().ref(binaries[targetField].ref).getDownloadURL()
                                .then((url)=>{
                                    //update the field for which this file was uploaded with the file url
                                    var UpdateBid = {};                                   
                                    UpdateBid[targetField] = url;
                                    firebase.firestore().collection('bids').doc(payload.bid.id).update(UpdateBid);
                                    return;
                                })
                        })
                    }
                    return binaries;
                })
                .then(() => {
                    commit('createOfferte',payload.bid);
                    commit('setLoading',false);
                    payload.router.push('/offerte/'+payload.bid.id);
                })
                .catch(function(error) {
                    commit('setLoading',false);
                    commit('setError',error);
                    console.error("Error writing document: ", error);
                });
        },
        clearError({commit}){
            commit('clearError');
        },
        login ({commit,dispatch}, payload) {
            commit('setLoading',true);
            commit('clearError');
            firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
            firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
              .then(
                  
                user => {
                    commit('setLoading',false);
                    const newUser = {
                        id: user.uid
                  }
                  console.log("User logged in : " + payload.email);
                  commit('setUser', newUser);
                  dispatch('loadData');
                  
                }
              )
              .catch(
                error => {
                  commit('setLoading',false);
                  commit('setError',error);
                  console.log(error)
                }
              )
          },
        autoLogin({commit,dispatch}, payload) {
            console.log(payload);
            commit('setUser',{id:payload.uid});
            dispatch('loadData');

        },
        logout({commit}){
            commit('setUser',null);
            firebase.auth().signOut();
        }
    },
    getters:{
        loadedOffertes(state){
            return state.loadedOffertes.sort((offerteA,offerteB) => {
                return offerteA.date > offerteB.date;}) 
        },
        loadedOfferte(state) {
            return(offerteId) => {
                return state.loadedOffertes.find((offerte) => {
                    return offerte.id == offerteId;

                })
            }
        },
        questions(state){
            return state.questions.sort((questionA,questionB) => {
                return questionA.sort > questionB.sort; 
            })
        },
        loadPictures(state){
            return state.pictures;
        },
        user(state){
            return state.user;
        },
        error(state){
            return state.error
        },
        loading(state){
            return state.loading
        }



    }
})